import { Injectable } from '@angular/core';
import { formDataState, tableDataState } from '../invite-user.state';
import { InviteUserService } from '../../services/invite-user.service';
import {
  inviteUserRoles,
  param,
  paramValue,
  PayloadData,
  tableState,
  errorMsg,
} from '../../models/invite-user.model';
import { HttpParams } from '@angular/common/http';
import { UserRoles } from '../../../../SGRE-shared/constants/app-constant';
import { take } from 'rxjs';
import * as SubmitAction from '../actions/submit-InviteUser.action';
import { Store } from '@ngrx/store';

@Injectable()
export class InviteUserEffectsService {
  constructor(
    private inviteUserService: InviteUserService,
    private Store: Store
  ) {}

  getSubmitPayload(): PayloadData {
    let formData: formDataState;
    let tableData: tableDataState;
    let loginUser: string[];
    let requestArray: tableState[];
    let params = new HttpParams();
    let user: string;

    this.inviteUserService
      .getFormData()
      .pipe(take(1))
      .subscribe((data) => (formData = data));
    this.inviteUserService
      .getTable()
      .pipe(take(1))
      .subscribe((data) => (tableData = data));
    this.inviteUserService
      .getUserRole()
      .pipe(take(1))
      .subscribe((data) => (loginUser = data));

    if (
      formData.userType === inviteUserRoles.SGRE &&
      loginUser.includes(UserRoles.SGRE_ADMIN)
    ) {
      if (
        formData.userRole === inviteUserRoles.SALES &&
        tableData &&
        tableData.salesTableData
      ) {
        params = params.append(param.EMAIL, formData.email);
        params = params.append(param.SGRE, paramValue.FALSE);
        requestArray = tableData.salesTableData.map((item) => ({
          legalEntityId: item.id,
          requester: false,
          customerAdmin: false,
          approver: false,
          salesRep: true,
        }));
      } else {
        params = params.append(param.EMAIL, formData.email);
        params = params.append(param.SGRE, paramValue.TRUE);
        requestArray = [];
      }
      user = inviteUserRoles.INTERNAL;
    } else {
      requestArray = tableData.notSalesTableData.map((item) => ({
        legalEntityId: item.id,
        requester: item.Requester,
        customerAdmin: item.CustomerAdmin,
        approver: item.Purchaser,
        salesRep: false,
      }));
      if (loginUser.includes(UserRoles.SGRE_ADMIN)) {
        params = params.append(param.SAME_COMPANY, paramValue.FALSE);
        params = params.append(param.INVITATION_TYPE, paramValue.INT_EXT);
      } else {
        params = params.append(
          param.SAME_COMPANY,
          formData.companyExt === param.MY_COMPANY
        );
        params = params.append(param.INVITATION_TYPE, paramValue.EXT_EXT);
      }
      params = params.append(param.EMAIL, formData.email);
      params = params.append(param.FIRST_NAME, formData.firstName);
      params = params.append(param.COMPANY, formData?.company);
      params = params.append(param.LAST_NAME, formData.lastName);
      user = inviteUserRoles.EXTERNAL;
    }
    return { requestArray, params, user } as PayloadData;
  }

  checkError(error: string) {
    let ignoredErrorMessages = new Set<string | number>([
      errorMsg.ext_not_create_int,
      errorMsg.ext_not_invite_int,
      errorMsg.int_not_create_ext,
      errorMsg.not_member_activeDir,
    ]);
    if (error && !ignoredErrorMessages.has(error))
      this.Store.dispatch(
        SubmitAction.updateErrorStatus({ errorStatus: true })
      );
  }
}
